import { render, staticRenderFns } from "./service-detail2.vue?vue&type=template&id=78f1bd5b&scoped=true&"
import script from "./service-detail2.vue?vue&type=script&lang=js&"
export * from "./service-detail2.vue?vue&type=script&lang=js&"
import style0 from "./service-detail2.vue?vue&type=style&index=0&id=78f1bd5b&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f1bd5b",
  null
  
)

export default component.exports